import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import UserAvatar from '@/components/app/UserAvatar';

function greeting(date = new Date()) {
  const h = date.getHours();
  if (h < 6) return 'Goedenacht';
  if (h < 12) return 'Goedemorgen';
  if (h < 18) return 'Goedemiddag';
  return 'Goedenavond';
}

/** Compact mobile header — deliberately one row, so the summary card sits high. */
export default function MobileHeader() {
  const { user } = useAuth();
  const firstName = (user?.name || '').trim().split(/\s+/)[0] || '';

  return (
    <header className="md:hidden flex items-center justify-between h-14 px-4 border-b border-dd-line bg-dd-bg">
      <Link to="/dashboard" className="flex items-center gap-2 min-w-0" aria-label="DriverDash">
        <img src="/dd-icon.png" alt="" className="w-6 h-6 brand-accent-logo flex-shrink-0" />
        <span className="text-[15px] font-bold tracking-tight text-dd-text">DriverDash</span>
      </Link>

      <Link to="/settings" className="flex items-center gap-2.5 min-w-0" data-testid="mobile-header-profile">
        <span className="text-[13px] text-dd-muted truncate">
          {greeting()}, <span className="text-dd-text font-semibold">{firstName}</span>
        </span>
        <UserAvatar size={32} showStatus />
      </Link>
    </header>
  );
}
